export default "__VITE_ASSET__fVLNZRvM__";